import { ReactNode, useState } from 'react'
import { DataManagementHeaderSlotContext } from './DataManagementHeaderSlotContext'

// Provider component to wrap the application
export function DataManagementHeaderSlotProvider({
    children,
}: {
    children: ReactNode
}) {
    const [slot, setSlot] = useState<ReactNode>(null)

    return (
        <DataManagementHeaderSlotContext.Provider value={{ slot, setSlot }}>
            {children}
        </DataManagementHeaderSlotContext.Provider>
    )
}
